import styled, { css } from "styled-components";
import Colours from '@shared/ui/atoms/Colours';

export const WEEK_WIDTH = 230;
export const DAY_WIDTH = WEEK_WIDTH / 7;
export const ROW_HEIGHT = 50;
// Taller than the date and team rows: user rows carry the schengen pill under the name.
export const USER_ROW_HEIGHT = 64;
export const USER_ROW_HEIGHT_MOBILE = 100;
export const PROJECT_ROW_HEIGHT = 32;

export const WallPlannerRow = styled.div<any>`
  display: flex;
  position: relative;
  // Earlier rows stack above later ones so that content overhanging the bottom of a row, such as the
  // schengen day count, is not painted over by the row below. Row 0 needs this as much as any other.
  ${props => props.position !== undefined ? css`z-index: ${1000 - props.position}` : ``};
`

export const WeekCell = styled.div`
  display: flex;
  flex: 1;
  min-width: ${WEEK_WIDTH}px;
  max-width: ${WEEK_WIDTH}px;
`

export const DayCell = styled.div<any>`
  flex: 1;
  height: 100%;
  ${props => css`background-color: ${props.weekend ? Colours.veryLightGrey : 'white'};`};
  ${props => css`background-color: ${props.weekend ? Colours.veryLightGrey : 'white'};`};
`

export const BorderDayCell = styled(DayCell)<any>`
  border-right: 1px solid #DEDEDE;
`
